import React from 'react';
import DynamicFormField from './DynamicFormField';

/**
 * ParameterEditor - Renders a group of parameter fields based on schema
 * Used for indicator parameters, rule parameters, etc.
 */
const ParameterEditor = ({
  parameters = [],
  values = {},
  onChange,
  errors = {},
  disabled = false,
  title,
  columns = 2,
}) => {
  if (!parameters || parameters.length === 0) {
    return null;
  }

  // Calculate grid classes based on columns
  const getGridClass = () => {
    switch (columns) {
      case 1: return 'grid-cols-1';
      case 2: return 'grid-cols-1 sm:grid-cols-2';
      case 3: return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3';
      case 4: return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4';
      default: return 'grid-cols-1 sm:grid-cols-2';
    }
  };

  return (
    <div>
      {title && (
        <>
          <h4 className="text-sm font-medium text-base-content/70 mb-2">{title}</h4>
          <div className="divider my-2"></div>
        </>
      )}
      
      <div className={`grid ${getGridClass()} gap-4`}>
        {parameters.map((param) => (
          <DynamicFormField
            key={param.name}
            schema={param}
            value={values[param.name]}
            onChange={(value) => onChange(param.name, value)}
            error={errors[param.name]}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};

export default ParameterEditor;
